import { useEffect, useState } from "react";

function getMaxScrollTop() {
  const rootScrollTop = Math.max(
    window.scrollY || 0,
    document.documentElement?.scrollTop || 0,
    document.body?.scrollTop || 0,
    document.scrollingElement?.scrollTop || 0
  );

  const elementScrollTop = Array.from(document.querySelectorAll("*"))
    .reduce((maxScrollTop, element) => {
      return Math.max(maxScrollTop, element.scrollTop || 0);
    }, 0);

  return Math.max(rootScrollTop, elementScrollTop);
}

function scrollEverythingToTop() {
  window.scrollTo({ top: 0, behavior: "smooth" });
  document.scrollingElement?.scrollTo({ top: 0, behavior: "smooth" });
  document.documentElement?.scrollTo({ top: 0, behavior: "smooth" });
  document.body?.scrollTo({ top: 0, behavior: "smooth" });

  Array.from(document.querySelectorAll("*")).forEach((element) => {
    if (element.scrollTop > 0) {
      element.scrollTo({ top: 0, behavior: "smooth" });
    }
  });
}

export default function ScrollToTopButton() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    let frameId = 0;

    const updateVisibility = () => {
      window.cancelAnimationFrame(frameId);
      frameId = window.requestAnimationFrame(() => {
        setVisible(getMaxScrollTop() > 300);
      });
    };

    updateVisibility();
    window.addEventListener("scroll", updateVisibility, true);
    document.addEventListener("scroll", updateVisibility, true);
    window.addEventListener("resize", updateVisibility);

    const intervalId = window.setInterval(updateVisibility, 400);

    return () => {
      window.cancelAnimationFrame(frameId);
      window.clearInterval(intervalId);
      window.removeEventListener("scroll", updateVisibility, true);
      document.removeEventListener("scroll", updateVisibility, true);
      window.removeEventListener("resize", updateVisibility);
    };
  }, []);

  return (
    <button
      type="button"
      aria-label="Nach oben"
      title="Nach oben"
      className={`scroll-to-top-button ${visible ? "scroll-to-top-visible" : ""}`}
      onClick={scrollEverythingToTop}
    >
      <span aria-hidden="true" className="scroll-to-top-icon">&#8593;</span>
    </button>
  );
}


